// fill in both in order to get proper intellisense
export type BaseDict = {
    LiveStreamingTooltip: string,
    StatisticsTooltip: string,
    TabletMobileDraw: string,
    Today: string,
    Tomorrow: string,
    YourTab: string,
    PersonalizedHighlightsTabLabel: string,
    Months: Object;
}
export const BaseDict: BaseDict = {
    LiveStreamingTooltip: "Live Streaming Available!",
    StatisticsTooltip: "Statistics Available!",
    TabletMobileDraw: "X",
    Today: "Today",
    Tomorrow: "Tomorrow",
    YourTab: "YourTab",
    PersonalizedHighlightsTabLabel: "Highlights",
    Months: {
        0: "January",
        1: "February",
        2: "March",
        3: "April",
        4: "May",
        5: "June",
        6: "July",
        7: "August",
        8: "September",
        9: "October",
        10: "November",
        11: "December"
    }
}